import { ReactSVG } from 'react-svg';
import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';

import './style.sass';

import logo from 'assets/img/icons/white-logo.svg';
import plusIcon from 'assets/img/icons/plus-icon.svg';

import { useBreakpointType } from 'app/services/breakpoints';
import { AppViewModel } from 'app/viewModels';
import { MenuButton } from '../MenuButton';
import { BreadCrumbs } from '../BreadCrumbs';
import { Routes } from 'src/types/routes';
import { UserProfile } from '../../UserProfile';
import { Button } from '../Button';

export const Header = () => {
    const { isDesktop } = useBreakpointType();

    return (
        isDesktop
            ? <DesktopHeader />
            : <ResponsiveHeader />
    );
};

export const DesktopHeader = observer(() => {
    const isDefaultUser = AppViewModel.Instance.userRole.isDefaultUser;

    return (
        <div className="app-header">
            <div className="left-wrapper">
                <BreadCrumbs />
            </div>

            <div className="right-wrapper">
                {isDefaultUser && (
                    <div className="create-campaign-btn">
                        <Button
                            text="create campaign"
                            iconSrc={plusIcon}
                            size='big'
                            to={Routes.Campaigns}
                        />
                    </div>
                )}
                <UserProfile />
            </div>
        </div>
    );
});


export const ResponsiveHeader = observer(() => {
    const onClickMenuBtn = () => {
        AppViewModel.Instance.isMenuOpened.toggle();
    };
    const isMenuOpened = AppViewModel.Instance.isMenuOpened.value;

    const onClickLogo = useCallback(() => {
        window.location.assign(Routes.Home);
    }, []);

    return (
        <div className="app-header">
            <div className="left-wrapper">
                <MenuButton isActive={isMenuOpened} onClickBtn={onClickMenuBtn} />
            </div>

            <div className="app-header__logo" onClick={onClickLogo}>
                <ReactSVG src={logo} />
            </div>

            <div className="right-wrapper">
                <UserProfile />
            </div>
        </div>
    );
});
